import type {
  StakeholderContact,
  AddStakeholderContactRequestParams,
  AddStakeholderContactRequestPayload,
  UpdateStakeholderContactRequestParams,
  UpdateStakeholderContactRequestPayload,
  DeleteStakeholderContactRequestParams,
  GetStakeholderContactsRequestParams,
  GetStakeholderContactsRequestResponse,
  AddMultipleStakeholderContactsRequestParams,
  AddMultipleStakeholderContactsRequestPayload,
  AddMultipleStakeholderContactsRequestResponse
} from '@gat-ship/types'
import { useGsCloudBackend } from '@gat-ship/http-client'

export function useStakeholderApiCalls() {
  const { apiGet, apiPost, apiPut, apiDelete } = useGsCloudBackend()

  /** Gets a list of contacts for a given stakeholder. */
  async function getStakeholderContactsRequest(
    params: GetStakeholderContactsRequestParams
  ) {
    return await apiGet<GetStakeholderContactsRequestResponse>(
      `stakeholders/${params.stakeholderId}/contacts`,
      { params: params.queryParams }
    )
  }

  async function addStakeholderContactRequest(
    params: AddStakeholderContactRequestParams
  ) {
    return await apiPost<
      { newState: StakeholderContact },
      AddStakeholderContactRequestPayload
    >(`stakeholders/contacts`, params.payload, params.commandId)
  }

  async function updateStakeholderContactRequest(
    params: UpdateStakeholderContactRequestParams
  ) {
    return await apiPut<
      { newState: StakeholderContact },
      UpdateStakeholderContactRequestPayload
    >(
      `stakeholders/contacts/${params.contactId}`,
      params.payload,
      params.commandId
    )
  }

  async function deleteStakeholderContactRequest(
    params: DeleteStakeholderContactRequestParams
  ) {
    return await apiDelete<{ newState: StakeholderContact }, undefined>(
      `stakeholders/contacts/${params.contactId}`,
      undefined,
      params.commandId
    )
  }

  async function addMultipleStakeholderContactsRequest(
    params: AddMultipleStakeholderContactsRequestParams
  ) {
    return await apiPost<
      AddMultipleStakeholderContactsRequestResponse,
      AddMultipleStakeholderContactsRequestPayload
    >(`stakeholders/contacts/batch-add`, params.payload, params.commandId)
  }

  return {
    getStakeholderContactsRequest,
    addStakeholderContactRequest,
    updateStakeholderContactRequest,
    deleteStakeholderContactRequest,
    addMultipleStakeholderContactsRequest
  }
}
